module.exports = __webpack_public_path__ + "img/history5.9b53ac48.jpg";